// hubs object includes the entry point and urls of each hub that uses this template
const hubs = {
  base: 'www.intercom.com/resources/', //https
};

const devOptions = {
  shortHubUrl: hubs.base, //change me to the base url of your hub (no http(s) or www)
  fullHubUrl: `https://${hubs.base}` + '?ufcc_onbrand_local', //exact url to access hub, leave onbrand query string
  cihostFolder: 'intercom', //change me to the cihost folder name
  remindMeToGit: true,
  notifyOnBuildSuccess: true, //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;



// WEBPACK FOOTER //
// ./dev-options.js